import { TextInput, Textarea, Stack, Group, Button } from "@mantine/core";
import { useForm } from "@mantine/form";
import { Correction } from "../../../services/admin/corrections.service";

export interface CorrectionFormValues {
  correction: string;
  description: string;
}

interface CorrectionFormProps {
  initialValues?: Correction;
  onSubmit: (values: CorrectionFormValues) => void;
  onCancel: () => void;
  submitLabel: string;
  isSubmitting?: boolean;
}

const CorrectionForm = ({
  initialValues,
  onSubmit,
  onCancel,
  submitLabel,
  isSubmitting,
}: CorrectionFormProps) => {
  const form = useForm<CorrectionFormValues>({
    initialValues: {
      correction: initialValues?.correction || "",
      description: initialValues?.description || "",
    },
    validate: {
      correction: (value) => (!value ? "Correction is required" : null),
    },
  });

  return (
    <form
      noValidate
      onSubmit={form.onSubmit(onSubmit)}
      style={{ display: "flex", flexDirection: "column", gap: "12px" }}
    >
      <Stack gap="md">
        <TextInput
          label="Correction"
          placeholder="Enter correction type"
          required
          {...form.getInputProps("correction")}
        />

        <Textarea
          label="Description"
          placeholder="Enter correction description"
          minRows={3}
          {...form.getInputProps("description")}
        />

        <Group justify="flex-end" mt="md">
          <Button variant="subtle" onClick={onCancel} type="button">
            Cancel
          </Button>
          <Button type="submit" loading={isSubmitting}>
            {submitLabel}
          </Button>
        </Group>
      </Stack>
    </form>
  );
};

export default CorrectionForm;

export { useForm } from "@mantine/form";
